import { useFlags } from 'launchdarkly-react-client-sdk';
import { Landmark, Pencil } from 'lucide-react';
import { Button } from '../../../../../design-system/button/button';
import { Inline } from '../../../../../design-system/inline/inline';
import { PayeeCheckBadgeWrapper } from './payee-check-badge-wrapper';
import { LatestPayeeCheckBadgeConfig } from './payroll-summary-column-definition';

type EmployeeNameCellProps = {
  employeeName: string;
  latestPayeeCheckBadge: LatestPayeeCheckBadgeConfig;
};

export const EmployeeNameCell = ({ employeeName, latestPayeeCheckBadge }: EmployeeNameCellProps) => {
  const { isVopPayrollLive, isVopPayrollWalkFlowLive } = useFlags<{
    isVopPayrollLive: boolean;
    isVopPayrollWalkFlowLive: boolean;
  }>();

  return (
    <Inline space={4}>
      <span>{employeeName}</span>

      {isVopPayrollLive && latestPayeeCheckBadge.isVisible && (
        <Inline space={4} wrap="nowrap">
          <Inline space={1} wrap="nowrap">
            <div className="h-4 w-4 text-seapoint-gray">
              <Landmark strokeWidth={1} className="h-full w-full" />
            </div>

            <PayeeCheckBadgeWrapper tooltipConfig={latestPayeeCheckBadge.tooltipConfig}>
              <div className="h-4 w-4">{latestPayeeCheckBadge.icon}</div>
            </PayeeCheckBadgeWrapper>
          </Inline>

          {isVopPayrollWalkFlowLive && latestPayeeCheckBadge.editPayrollRecordConfig.isVisible && (
            <Button
              variant="ghost"
              size="none"
              onClick={latestPayeeCheckBadge.editPayrollRecordConfig.onEditPayrollRecord}
            >
              <div className="h-4 w-4 text-seapoint-gray">
                <Pencil strokeWidth={1} className="h-full w-full" />
              </div>
            </Button>
          )}
        </Inline>
      )}
    </Inline>
  );
};
